import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class InvestorAccrualCriteria extends Model.CriteriaBase {
    static typeName = "InvestorAccrualCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Rules.Required()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerInvestmentName: string = "";

    protected static addBusinessRules(rules: Validation.Rules<InvestorAccrualCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investor Accrual Criteria";
    }
}